// extracted by mini-css-extract-plugin
export var container = "_8s-0";
export var error = "_8s-9";
export var label = "_8s-5";
export var light = "_8s-6";
export var md = "_8s-3";
export var sm = "_8s-2";
export var thin = "_8s-8";
export var thinBold = "_8s-7";
export var vertical = "_8s-4";
export var xs = "_8s-1";